import type { Organization, OrganizationNew } from "./organization";
import {
  contactMethodItems,
  contactMethodsForSave,
  personContactMethodsToFormkit,
} from "@/views/person/person";

export default {
  addAuthRequestFields,
  getInitialData,
  skinnyResponseAdapter,
  responseAdapter,
  requestAdapter,
  fromFormkit,
  toFormkit,
};

function addAuthRequestFields(entity: Organization) {
  entity._authRequestFields = ["id"];
  return entity;
}
function getInitialData() {
  const result: OrganizationNew = {
    name: "",
    contactMethods: [],
  };
  result._authRequestFields = ["id"];
  return result;
}

/** Be sure to await this when using it. Commonly used for lists and child lists */
async function skinnyResponseAdapter(response: { data: Organization }) {
  addAuthRequestFields(response.data);
  response.data.displayName = response.data.name;
  return response.data as Organization;
}

/** Be sure to await this when using it. */
async function responseAdapter(response: { data: Organization }) {
  await skinnyResponseAdapter(response);

  return response.data;
}

function requestAdapter(data: Organization | OrganizationNew) {
  const { affiliations: _affiliations, ...rest } = data as Organization & { affiliations?: unknown };
  return {
    ...rest,
    contactMethods: contactMethodsForSave(contactMethodItems(data.contactMethods)),
  };
}

// Convert server data for use in the page's form (which may have groupings, etc different from the server data)
function toFormkit<T extends Organization | OrganizationNew>(data: T) {
  data.contactMethods = personContactMethodsToFormkit(contactMethodItems(data.contactMethods));
}

// Convert formkit data to prep it for sending to the server (which is probably flatter than the fk data)
function fromFormkit(data: Organization | OrganizationNew) {
  data.contactMethods = contactMethodsForSave(contactMethodItems(data.contactMethods));
}
